/**
 * 判断元素是否在视口中可见
 * copy from rc-util/lib/Dom/isVisible.js
 */
export function isVisible(element) {
    if (!element) {
        return false;
    }
  
    if (element.offsetParent) {
        return true;
    }
  
    if (element.getBBox) {
        var box = element.getBBox();
  
        if (box.width || box.height) {
            return true;
        }
    }
  
    if (element.getBoundingClientRect) {
        var _box = element.getBoundingClientRect();
  
        if (_box.width || _box.height) {
            return true;
        }
    }
  
    return false;
}

/**
 * 元素在视口中可见时触发
 * copy from rc-picker/src/utils/uiUtil.ts
 */
export function waitElementReady(element, callback) {
    let id;
  
    function tryOrNextFrame() {
        if (isVisible(element)) {
            callback();
        } else {
            id = requestAnimationFrame(() => {
                tryOrNextFrame();
            });
        }
    }
  
    tryOrNextFrame();
  
    return () => {
        cancelAnimationFrame(id);
    };
}